/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Form, Input, Select, Button, message, Modal } from 'antd';
import {
	ArrowLeftOutlined,
	EditOutlined,
	UnorderedListOutlined,
	CloudUploadOutlined,
	HolderOutlined,
	MinusCircleOutlined,
	// EyeOutlined,
	// CloseOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import { Box, Flex } from 'atoms';
import {
	PageContainer,
	HeaderContainer,
	HeaderRightSection,
	Title,
	Subtitle,
	BackButton,
} from 'componentsv2/forms/client/clientFormStyles';
import BulkUploadModal from 'componentsv2/modals/BulkUploadModal';
import ManageTripsModal from 'componentsv2/modals/ManageTripsModal';
import {
	createRouteV2,
	updateRouteV2,
	getRouteByIdV2,
	getProjectNodesV2,
	bulkUploadRoutesV2,
} from 'store/routeSliceV2';
import { getProjectListV2, getProjectByIdV2 } from 'store/projectSliceV2';
import { searchVendorFiltersV2, searchVendorV2 } from 'store/vendorSliceV2';
import { searchVehiclesV2 } from 'store/vehicleSliceV2';
import { getSignedUrl } from 'store/commonSlice';
import { generateTripsFromRouteWeekOffV2 } from 'store/tripSliceV2';

const ROUTE_LIST_ROUTE = '/routes';
const BULK_UPLOAD_MESSAGE_KEY = 'bulk-upload';

const FormContainer = styled(Box)`
	background: #fff;
	border: 1px solid #e8e8e8;
	// border-radius: 8px;
	padding: 32px 40px;
	margin-bottom: 24px;
	max-width: 1200px;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
`;

const FormRow = styled(Flex)`
	margin-bottom: 24px;
	gap: 24px;

	&:last-of-type {
		margin-bottom: 0;
	}
`;

const FormColumn = styled(Box)`
	flex: 1;
	min-width: 0;
`;

const StyledForm = styled(Form)`
	.ant-form-item-label > label {
		font-weight: 500;
		font-size: 14px;
		color: #1e293b;
	}
	.ant-form-item {
		margin-bottom: 20px;
	}
	.ant-input,
	.ant-select-selector {
		// border-radius: 6px;
		border: 1px solid #e2e8f0;
		font-size: 14px;
	}
	.ant-input {
		height: 40px;
	}
	.ant-select-selector {
		height: 40px !important;
		padding: 4px 11px !important;
	}
	.ant-select-multiple .ant-select-selector {
		height: auto !important;
		min-height: 40px !important;
	}
	.ant-input:disabled,
	.ant-input[disabled],
	.ant-select-disabled .ant-select-selector {
		background-color: #f5f5f5 !important;
		color: #666;
		cursor: not-allowed;
	}
`;

const ManageTripsButton = styled(Button)`
	height: 40px;
	padding: 0 20px;
	font-weight: 500;
	border: 1px solid #1890ff;
	color: #1890ff;
	background: #fff;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		border-color: #40a9ff;
		color: #40a9ff;
		background: #fff;
	}
`;

const EditButton = styled(Button)`
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	background-color: #1e40af;
	border: 1px solid #1e40af;
	color: white;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #1e3a8a !important;
		border-color: #1e3a8a !important;
		color: white !important;
	}
`;

const UpdateButton = styled(Button)`
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	// border-radius: 6px;
`;

const BulkUploadButton = styled(Button)`
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	background: #fff;
	border: 1px solid #d9d9d9;
	color: #000;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		border-color: #18405d !important;
		color: #18405d !important;
		background: #fff !important;
	}
`;

const NodeSequenceLink = styled.button`
	border: none;
	background: transparent;
	color: #1677ff;
	font-size: 14px;
	font-weight: 500;
	padding: 0;
	cursor: pointer;
	text-decoration: underline;
	text-align: right;
	display: block;
	margin-top: -12px;
	margin-bottom: 20px;
	margin-left: auto;

	&:disabled {
		color: #94a3b8;
		cursor: not-allowed;
		text-decoration: none;
	}
`;

const SequenceContainer = styled(Box)`
	border: 1px solid #e4e7ec;
	background: #f8fafc;
	padding: 16px;
	border-radius: 8px;
	margin-top: 16px;
`;

const SequenceHeader = styled(Flex)`
	margin-bottom: 12px;
	justify-content: space-between;
	align-items: center;
`;

const SequenceHeading = styled.h3`
	margin: 0;
	font-size: 28px;
	font-weight: 600;
	line-height: 36px;
	color: #101828;
`;

const SequenceHint = styled.span`
	font-size: 12px;
	color: #98a2b3;
`;

const SequenceRow = styled(Flex)`
	min-height: 52px;
	background: #fff;
	border: 1px solid #d0d5dd;
	border-radius: 8px;
	padding: 10px 12px;
	margin-bottom: 10px;
	align-items: center;
	justify-content: space-between;
`;

const SequenceIndex = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 18px;
	height: 18px;
	padding: 0 4px;
	font-size: 11px;
	line-height: 1;
	font-weight: 600;
	background: #18405d;
	color: #fff;
	border-radius: 4px;
	margin-right: 10px;
`;

const SequenceTag = styled.span`
	font-size: 10px;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 6px;
	margin-right: 8px;
	background: ${(props) => (props.$variant === 'end' ? '#fee2e2' : '#dcfce7')};
	color: ${(props) => (props.$variant === 'end' ? '#b42318' : '#067647')};
`;

const isEqualArray = (first = [], second = []) => {
	if (first.length !== second.length) return false;
	return first.every((value, index) => value === second[index]);
};

const mergeNodeOrder = (selectedNodeIds = [], previousOrder = []) => {
	const selectedSet = new Set(selectedNodeIds);
	const kept = previousOrder.filter((id) => selectedSet.has(id));
	const missing = selectedNodeIds.filter((id) => !kept.includes(id));
	return [...kept, ...missing];
};

const buildDisplaySequence = (orderedNodeIds = [], tripType) => {
	if (tripType === 'round_trip' && orderedNodeIds.length > 1) {
		const firstNodeId = orderedNodeIds[0];
		const lastNodeId = orderedNodeIds[orderedNodeIds.length - 1];
		if (firstNodeId === lastNodeId) {
			return orderedNodeIds;
		}
		return [...orderedNodeIds, firstNodeId];
	}
	return orderedNodeIds;
};

// const ViewBanner = styled(Box)`
// 	background: #1e40af;
// 	color: #fff;
// 	padding: 16px 24px;
// 	display: flex;
// 	align-items: center;
// 	justify-content: space-between;
// 	gap: 16px;
// 	margin-top: 24px;
// 	border-radius: 0 0 8px 8px;
// `;

// const AskToEditButton = styled(Button)`
// 	background: rgba(255, 255, 255, 0.2);
// 	border: 1px solid rgba(255, 255, 255, 0.5);
// 	color: #fff;
// 	height: 36px;

// 	&:hover {
// 		background: rgba(255, 255, 255, 0.3) !important;
// 		border-color: rgba(255, 255, 255, 0.6) !important;
// 		color: #fff !important;
// 	}
// `;

/**
 * Extract node_ids from record.nodes preserving sequence_order.
 * Also handles source_node and destination_node structure.
 * nodes: [{ node_id: 4, sequence_order: 1 }, { node_id: 5, sequence_order: 2 }]
 * OR source_node/destination_node: { node_id: 43, node_name: "...", sequence_order: 1 }
 * -> node_ids: [4, 5] (order of selection = sequence_order)
 */
const mapRecordToFormValues = (record) => {
	console.log('🔍 [mapRecordToFormValues] Record:', record);
	if (!record) return null;
	let node_ids = record.node_ids ?? [];

	// If no node_ids, try to extract from nodes array
	if (!node_ids.length && record.nodes?.length) {
		const sorted = [...record.nodes].sort(
			(a, b) => (a.sequence_order ?? 0) - (b.sequence_order ?? 0)
		);
		node_ids = sorted.map((n) => n.node_id ?? n.id);
	}

	// If still no node_ids, extract from source_node and destination_node
	if (!node_ids.length && (record.source_node || record.destination_node)) {
		const nodes = [];
		if (record.source_node?.node_id) {
			nodes.push(record.source_node);
		}
		if (record.destination_node?.node_id) {
			nodes.push(record.destination_node);
		}
		// Sort by sequence_order and extract node_ids
		const sorted = nodes.sort((a, b) => (a.sequence_order ?? 0) - (b.sequence_order ?? 0));
		node_ids = sorted.map((n) => n.node_id);
	}

	// Extract vehicle_ids from new `vehicles` array; fall back to legacy vehicle_id
	let vehicle_id;
	if (Array.isArray(record.vehicles) && record.vehicles.length > 0) {
		vehicle_id = record.vehicles.map((v) => v.id ?? v.value);
	} else if (record.vehicle_id) {
		vehicle_id = [record.vehicle_id];
	} else {
		vehicle_id = undefined;
	}

	return {
		route_name: record.route_name ?? record.routeName,
		project_id: record.project_id ?? record.project?.id,
		warehouse: record.warehouse ?? record.warehouse_name,
		vendor_id: record.vendor_id ?? record.vendor?.id,
		vehicle_id,
		node_ids,
		vehicle_type: record.vehicle_type_id ?? record.vehicle_type?.id ?? record.vehicle_type,
		trip_type: record.trip_type ?? record.movement_type ?? 'round_trip',
		movement_type: record.movement_type ?? 'round_trip',
		is_active: record.is_active !== false && record.is_active !== 0,
	};
};

/** Extract vehicle type from route record for display (vehicle_type_name) */
const getRouteVehicleType = (record) => {
	if (!record) return null;
	const id = record.vehicle_type_id ?? record.vehicle_type?.id ?? record.vehicle_type;
	const name =
		record.vehicle_type_name ??
		record.vehicle_type?.vehicle_type_name ??
		record.vehicle_type?.label;
	return id ? { id, name: name || null } : null;
};

export default function CreateRoutePageV2() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { id } = useParams();
	const location = useLocation();
	const [form] = Form.useForm();

	const isEditMode = Boolean(id);
	const passedRecord = location.state?.record;

	// Store route's vehicle type for display when navigating to edit (show vehicle_type_name, not id)
	const routeVehicleTypeRef = useRef({ id: null, name: null });

	// View mode: when edit mode, always start disabled. Only Edit button enables the form.
	const [isViewMode, setIsViewMode] = useState(isEditMode);
	// const [bannerVisible, setBannerVisible] = useState(isEditMode);
	const [loading, setLoading] = useState(false);
	const [projectOptions, setProjectOptions] = useState([]);
	const [vendorOptions, setVendorOptions] = useState([]);
	const [vehicleOptions, setVehicleOptions] = useState([]);
	const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]);
	const [nodeOptions, setNodeOptions] = useState([]);
	const [bulkUploadModalVisible, setBulkUploadModalVisible] = useState(false);
	const [uploadLoading, setUploadLoading] = useState(false);
	const [uploadedS3Key, setUploadedS3Key] = useState(null);
	const [uploadedFileName, setUploadedFileName] = useState(null);
	const [manageTripsModalVisible, setManageTripsModalVisible] = useState(false);
	const [currentRouteData, setCurrentRouteData] = useState(null);
	const [nodeSequenceModalVisible, setNodeSequenceModalVisible] = useState(false);
	const [nodeOrder, setNodeOrder] = useState([]);
	const [draggedNodeId, setDraggedNodeId] = useState(null);

	useEffect(() => {
		const fetchProjects = async () => {
			try {
				const result = await dispatch(
					getProjectListV2({
						filter_by: { is_active: true },
						pagination: { page: 1, per_page: 1000 },
					})
				);
				const projects = result?.rows || result?.projects || [];
				setProjectOptions(projects);
			} catch (error) {
				console.error('Error fetching projects:', error);
			}
		};
		fetchProjects();
	}, [dispatch]);

	useEffect(() => {
		const mapVendorToOption = (v) => ({
			value: v.id ?? v.value,
			label: v.name ?? v.label ?? v.vendor_name ?? 'Unknown',
		});
		const fetchOptions = async () => {
			try {
				// Prefer list_search (dropdown API); fallback to /search if no results (e.g. ACL or response shape)
				const vendorRes = await dispatch(
					searchVendorFiltersV2({ filter_by: { is_active: true }, limit: 1000 })
				);
				let vendorResults = vendorRes?.results ?? [];
				if (vendorResults.length === 0) {
					const searchRes = await dispatch(
						searchVendorV2({
							filter_by: { is_active: true },
							pagination: { page: 1, per_page: 1000 },
						})
					);
					vendorResults = searchRes?.rows ?? [];
				}
				setVendorOptions(vendorResults.map(mapVendorToOption));
			} catch (error) {
				console.error('Error fetching vendor options:', error);
			}
		};
		fetchOptions();
	}, [dispatch]);

	// Fetch vehicles when vendor is selected (POST /api/v2/search vehicle with filter_by.vendor_id)
	const vendorId = Form.useWatch('vendor_id', form);
	const vehicleTypeId = Form.useWatch('vehicle_type', form);
	const prevVendorIdRef = useRef(undefined);
	const prevVehicleTypeIdRef = useRef(undefined);

	// Effect 1: vendor changes → fetch ALL vehicles → build vehicleTypeOptions
	useEffect(() => {
		if (!vendorId) {
			setVehicleOptions([]);
			setVehicleTypeOptions([]);
			form.setFieldsValue({ vehicle_id: undefined, vehicle_type: undefined });
			prevVendorIdRef.current = vendorId;
			prevVehicleTypeIdRef.current = undefined;
			return;
		}
		const prevVendorId = prevVendorIdRef.current;
		prevVendorIdRef.current = vendorId;
		if (prevVendorId != null && prevVendorId !== vendorId) {
			form.setFieldsValue({ vehicle_id: undefined, vehicle_type: undefined });
			prevVehicleTypeIdRef.current = undefined;
		}
		const fetchAllVehiclesForTypes = async () => {
			try {
				const result = await dispatch(
					searchVehiclesV2({
						filter_by: { vendor_id: vendorId },
						pagination: { page: 1, per_page: 1000 },
					})
				);
				const vehicles = result?.rows ?? result?.vehicles ?? [];
				const typeMap = new Map();
				vehicles.forEach((v) => {
					const typeName =
						v.metadata?.vehicle_type_name ??
						v.vehicle_type_name ??
						v.vehicle_type?.label;
					const typeId =
						v.metadata?.vehicle_type_id ??
						v.vehicle_type_id ??
						v.vehicle_type?.id ??
						v.vehicle_type;
					if (typeName || typeId) {
						const key = typeId ?? typeName;
						if (!typeMap.has(key)) {
							typeMap.set(key, {
								value: typeId ?? typeName,
								label: typeName ?? String(typeId),
							});
						}
					}
				});
				const routeVt = routeVehicleTypeRef.current;
				if (routeVt?.id && !typeMap.has(routeVt.id)) {
					typeMap.set(routeVt.id, {
						value: routeVt.id,
						label: routeVt.name ?? String(routeVt.id),
					});
				}
				setVehicleTypeOptions(Array.from(typeMap.values()));
			} catch (error) {
				console.error('Error fetching vehicle types:', error);
				setVehicleTypeOptions([]);
			}
		};
		fetchAllVehiclesForTypes();
	}, [vendorId, dispatch, form]);

	// Effect 2: vehicle type changes → fetch vehicles filtered by type → build vehicleOptions
	useEffect(() => {
		if (!vendorId || !vehicleTypeId) {
			setVehicleOptions([]);
			if (!vendorId) return;
			return;
		}
		const prevVehicleTypeId = prevVehicleTypeIdRef.current;
		prevVehicleTypeIdRef.current = vehicleTypeId;
		if (prevVehicleTypeId != null && prevVehicleTypeId !== vehicleTypeId) {
			form.setFieldsValue({ vehicle_id: undefined });
		}
		const fetchVehiclesByType = async () => {
			try {
				const result = await dispatch(
					searchVehiclesV2({
						filter_by: {
							vendor_id: vendorId,
							vehicle_type_id: Number(vehicleTypeId),
						},
						pagination: { page: 1, per_page: 1000 },
					})
				);
				const vehicles = result?.rows ?? result?.vehicles ?? [];
				setVehicleOptions(
					vehicles.map((v) => ({
						value: v.id ?? v.value,
						label:
							v.label ?? v.vehicle_number ?? v.name ?? `Vehicle ${v.id ?? v.value}`,
					}))
				);
			} catch (error) {
				console.error('Error fetching vehicles by type:', error);
				setVehicleOptions([]);
			}
		};
		fetchVehiclesByType();
	}, [vendorId, vehicleTypeId, dispatch, form]);

	// Fetch nodes when project is selected (POST /api/v2/search project_nodes)
	const projectId = Form.useWatch('project_id', form);
	const selectedNodeIds = Form.useWatch('node_ids', form) || [];
	const selectedTripType = Form.useWatch('trip_type', form) || 'round_trip';

	useEffect(() => {
		setNodeOrder((prevOrder) => {
			const nextOrder = mergeNodeOrder(selectedNodeIds, prevOrder);
			return isEqualArray(prevOrder, nextOrder) ? prevOrder : nextOrder;
		});
	}, [selectedNodeIds]);

	const displaySequence = buildDisplaySequence(nodeOrder, selectedTripType);
	const nodeOptionMap = nodeOptions.reduce((acc, option) => {
		acc[option.value] = option.label;
		return acc;
	}, {});
	useEffect(() => {
		if (!projectId) {
			setNodeOptions([]);
			form.setFieldValue('node_ids', []);
			return;
		}
		const fetchProjectNodes = async () => {
			try {
				const nodes = await dispatch(getProjectNodesV2({ project_id: projectId }));
				const arr = Array.isArray(nodes) ? nodes : nodes?.data?.nodes ?? nodes?.nodes ?? [];
				setNodeOptions(
					arr.map((n) => ({
						value: n.node_id ?? n.id,
						label: n.node_name ?? n.name ?? `Node ${n.node_id ?? n.id}`,
					}))
				);
			} catch (error) {
				console.error('Error fetching project nodes:', error);
				setNodeOptions([]);
			}
		};
		fetchProjectNodes();
	}, [projectId, dispatch, form]);

	// When project_id from route row: fetch project by id and add to options, then pre-fill
	useEffect(() => {
		if (!isEditMode || !passedRecord) return;

		const projectIdValueFromRecord = passedRecord.project_id ?? passedRecord.project?.id;
		routeVehicleTypeRef.current = getRouteVehicleType(passedRecord) ?? { id: null, name: null };

		// Seed nodeOptions from all available node sources on the record
		setNodeOptions((prevOptions) => {
			const existingNodeIds = new Set(prevOptions.map((opt) => opt.value));
			const newOptions = [...prevOptions];

			const addNode = (nodeId, nodeName) => {
				if (nodeId && !existingNodeIds.has(nodeId)) {
					newOptions.push({
						value: nodeId,
						label: nodeName || `Node ${nodeId}`,
					});
					existingNodeIds.add(nodeId);
				}
			};

			if (Array.isArray(passedRecord.nodes)) {
				passedRecord.nodes.forEach((n) =>
					addNode(n.node_id ?? n.id, n.node_name ?? n.name)
				);
			}
			if (passedRecord.source_node?.node_id) {
				addNode(passedRecord.source_node.node_id, passedRecord.source_node.node_name);
			}
			if (passedRecord.destination_node?.node_id) {
				addNode(
					passedRecord.destination_node.node_id,
					passedRecord.destination_node.node_name
				);
			}

			return newOptions;
		});

		if (!projectIdValueFromRecord) {
			form.setFieldsValue(mapRecordToFormValues(passedRecord));
			return;
		}

		const ensureProjectAndPreFill = async () => {
			// If project already in options, just pre-fill
			const existing = projectOptions.some((p) => p.id === projectIdValueFromRecord);
			if (existing) {
				form.setFieldsValue(mapRecordToFormValues(passedRecord));
				return;
			}

			// Fetch project by id and add to options
			try {
				const project = await dispatch(getProjectByIdV2({ id: projectIdValueFromRecord }));
				if (project) {
					setProjectOptions((prev) => {
						const alreadyExists = prev.some((p) => p.id === projectIdValueFromRecord);
						if (alreadyExists) return prev;
						return [
							...prev,
							{
								id: project.id,
								project_name:
									project.project_name ??
									project.name ??
									project.project_code ??
									`Project ${projectIdValueFromRecord}`,
							},
						];
					});
				}
			} catch (error) {
				console.error('Error fetching project by id:', error);
			}

			// Pre-fill form with record values
			form.setFieldsValue(mapRecordToFormValues(passedRecord));
		};

		ensureProjectAndPreFill();
	}, [isEditMode, passedRecord, dispatch, form, projectOptions]);

	// Fetch full route data when in edit mode
	useEffect(() => {
		if (!isEditMode || !id) return;

		const fetchRoute = async () => {
			setLoading(true);
			try {
				const result = await dispatch(getRouteByIdV2({ id }));
				if (result) {
					routeVehicleTypeRef.current = getRouteVehicleType(result) ?? {
						id: null,
						name: null,
					};

					// Seed nodeOptions from all available node sources on the route
					setNodeOptions((prevOptions) => {
						const existingNodeIds = new Set(prevOptions.map((opt) => opt.value));
						const newOptions = [...prevOptions];

						const addNode = (nodeId, nodeName) => {
							if (nodeId && !existingNodeIds.has(nodeId)) {
								newOptions.push({
									value: nodeId,
									label: nodeName || `Node ${nodeId}`,
								});
								existingNodeIds.add(nodeId);
							}
						};

						// Add all nodes from the nodes array
						if (Array.isArray(result.nodes)) {
							result.nodes.forEach((n) =>
								addNode(n.node_id ?? n.id, n.node_name ?? n.name)
							);
						}

						// Add source_node and destination_node
						if (result.source_node?.node_id) {
							addNode(result.source_node.node_id, result.source_node.node_name);
						}
						if (result.destination_node?.node_id) {
							addNode(
								result.destination_node.node_id,
								result.destination_node.node_name
							);
						}

						return newOptions;
					});

					// Seed vehicleOptions with route's own vehicles so tags display labels
					if (Array.isArray(result.vehicles) && result.vehicles.length > 0) {
						setVehicleOptions((prev) => {
							const existingIds = new Set(prev.map((o) => o.value));
							const extras = result.vehicles
								.filter((v) => !existingIds.has(v.id ?? v.value))
								.map((v) => ({
									value: v.id ?? v.value,
									label: v.vehicle_number ?? v.label ?? `Vehicle ${v.id}`,
								}));
							return [...prev, ...extras];
						});
					}

					form.setFieldsValue(mapRecordToFormValues(result));
				}
			} catch (error) {
				message.error('Failed to load route details');
			} finally {
				setLoading(false);
			}
		};

		fetchRoute();
	}, [id, isEditMode, dispatch, form]);

	const handleEdit = () => {
		setIsViewMode(false);
		// setBannerVisible(false);
	};

	const handleManageTrips = () => {
		// Get current route data from form
		const formValues = form.getFieldsValue();
		const routeData = {
			id,
			route_id: id,
			route_name: formValues.route_name || passedRecord?.route_name,
			project_name: passedRecord?.project_name || formValues.project_id,
			project_id: formValues.project_id,
		};
		setCurrentRouteData(routeData);
		setManageTripsModalVisible(true);
	};

	const handleCloseManageTrips = () => {
		setManageTripsModalVisible(false);
		setCurrentRouteData(null);
	};

	// eslint-disable-next-line no-unused-vars
	const handleGenerateTrips = async (reason) => {
		if (!id) {
			message.error('Route ID is required to generate trips');
			return;
		}

		try {
			const result = await dispatch(
				generateTripsFromRouteWeekOffV2({
					route_id: id,
					setErrors: () => {},
				})
			);

			if (result?.status === 'success') {
				// Close modal after success
				setManageTripsModalVisible(false);
				// Optionally refresh route data or trips list
				// You can add a callback to refresh the trips in the modal if needed
			} else {
				message.error(result?.message || 'Failed to generate trips');
			}
		} catch (error) {
			console.error('Error generating trips:', error);
			message.error(error?.message || 'Failed to generate trips');
		}
	};

	const handleDeleteTrips = (tripIds, reason) => {
		message.info(`Delete trips: ${tripIds.join(', ')}. Reason: ${reason || 'Not provided'}`);
		// TODO: Implement delete trips API call
		// Close modal after success
		setManageTripsModalVisible(false);
	};

	const handleSubmit = async (values) => {
		setLoading(true);
		try {
			// Selection order = sequence_order: first selected = 1, second = 2, etc.
			const orderedNodeIds = mergeNodeOrder(values.node_ids || [], nodeOrder);

			const nodes = orderedNodeIds.map((node_id, index) => ({
				node_id: node_id,
				sequence_order: index + 1,
			}));

			const vehicle_ids = Array.isArray(values.vehicle_id)
				? values.vehicle_id.map(Number)
				: values.vehicle_id
				? [Number(values.vehicle_id)]
				: undefined;
			const action = isEditMode
				? updateRouteV2({ id, req_data: { vehicle_ids } })
				: createRouteV2({
						req_data: {
							route_name: values.route_name,
							project_id: values.project_id,
							warehouse_name: values.warehouse,
							trip_type: values.trip_type || values.movement_type || 'round_trip',
							movement_type: values.movement_type || values.trip_type || 'round_trip',
							vendor_id: values.vendor_id ? values.vendor_id : undefined,
							vehicle_ids,
							vehicle_type_id: values.vehicle_type,
							is_active: values.is_active !== false,
							...(nodes.length > 0 && { nodes }),
						},
				  });

			const result = await dispatch(action);

			if (result?.data?.id || result?.id) {
				navigate(ROUTE_LIST_ROUTE);
			}
		} catch (error) {
			message.error(error?.message || 'Failed to save route');
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		if (isEditMode) {
			setIsViewMode(true);
			// setBannerVisible(true);
		} else {
			navigate(ROUTE_LIST_ROUTE);
		}
	};

	const handleBulkUploadOpen = () => {
		setBulkUploadModalVisible(true);
	};

	const handleNodeSelectionChange = (nextSelectedNodes) => {
		const normalizedSelected = nextSelectedNodes || [];
		const mergedOrder = mergeNodeOrder(normalizedSelected, nodeOrder);
		form.setFieldValue('node_ids', normalizedSelected);
		setNodeOrder(mergedOrder);
	};

	const handleOpenNodeSequenceModal = () => {
		if (!selectedNodeIds.length) {
			message.warning('Please select nodes first');
			return;
		}
		setNodeSequenceModalVisible(true);
	};

	const handleResetSequence = () => {
		setNodeOrder([...selectedNodeIds]);
	};

	const handleRemoveNode = (nodeId) => {
		const nextSelected = selectedNodeIds.filter((idValue) => idValue !== nodeId);
		handleNodeSelectionChange(nextSelected);
	};

	const handleDragStart = (nodeId) => {
		setDraggedNodeId(nodeId);
	};

	const handleDropNode = (targetNodeId) => {
		if (!draggedNodeId || draggedNodeId === targetNodeId) {
			setDraggedNodeId(null);
			return;
		}

		const sourceIndex = nodeOrder.indexOf(draggedNodeId);
		const targetIndex = nodeOrder.indexOf(targetNodeId);
		if (sourceIndex < 0 || targetIndex < 0) {
			setDraggedNodeId(null);
			return;
		}

		const nextOrder = nodeOrder.filter((idValue) => idValue !== draggedNodeId);
		nextOrder.splice(targetIndex, 0, draggedNodeId);
		setNodeOrder(nextOrder);
		setDraggedNodeId(null);
	};

	const handleConfirmNodeSequence = () => {
		form.setFieldValue('node_ids', [...nodeOrder]);
		setNodeSequenceModalVisible(false);
	};

	const handleBulkUploadClose = () => {
		setBulkUploadModalVisible(false);
		setUploadedS3Key(null);
		setUploadedFileName(null);
		setUploadLoading(false);
	};

	// Handle file upload to S3 (called when file is selected in the modal)
	const handleFileUpload = async (file) => {
		console.log('📁 [Bulk Upload] Step 1: File selected, uploading to S3...', {
			fileName: file.name,
			fileSize: file.size,
			fileType: file.type,
		});

		setUploadLoading(true);
		message.loading({
			content: 'Uploading file to S3...',
			key: BULK_UPLOAD_MESSAGE_KEY,
		});

		try {
			// Step 1: Get signed URL for S3 upload
			console.log('🔑 [Bulk Upload] Getting signed URL for S3 upload...');
			const signedUrlResponse = await dispatch(
				getSignedUrl({
					url_type: 'upload',
					data: {
						entity: 'route_bulk_upload_v2',
						keys: [file.name],
						content_type: 'text/csv',
					},
				})
			);

			console.log('📊 [Bulk Upload] Signed URL response:', {
				hasResponse: !!signedUrlResponse,
				status: signedUrlResponse?.status,
				hasData: !!signedUrlResponse?.data,
			});

			if (!signedUrlResponse || signedUrlResponse.status !== 'success') {
				throw new Error('Failed to get S3 upload URL');
			}

			const uploadData = signedUrlResponse.data?.[0];
			if (!uploadData?.url || !uploadData?.key) {
				throw new Error('Invalid S3 upload URL response');
			}

			const { url: uploadUrl, key: s3Key } = uploadData;
			console.log('📤 [Bulk Upload] Step 2: Uploading to S3...', { s3Key });

			// Step 2: Upload file to S3
			const uploadResponse = await fetch(uploadUrl, {
				method: 'PUT',
				body: file,
				headers: {
					'Content-Type': file.type || 'text/csv',
				},
			});

			if (!uploadResponse.ok) {
				throw new Error(`S3 upload failed: ${uploadResponse.statusText}`);
			}

			console.log('✅ [Bulk Upload] File uploaded to S3 successfully', { s3Key });

			// Store S3 key for later submission
			setUploadedS3Key(s3Key);
			setUploadedFileName(file.name);

			message.success({
				content: 'File uploaded successfully. Click Submit to process.',
				key: BULK_UPLOAD_MESSAGE_KEY,
				duration: 3,
			});
		} catch (error) {
			console.error('❌ [Bulk Upload] File upload error:', error);
			message.error({
				content: error?.message || 'Failed to upload file to S3',
				key: BULK_UPLOAD_MESSAGE_KEY,
				duration: 5,
			});
			setUploadedS3Key(null);
			setUploadedFileName(null);
		} finally {
			setUploadLoading(false);
		}
	};

	const handleBulkUploadSubmit = async () => {
		console.log('📤 [Bulk Upload] Submit button clicked', {
			uploadedS3Key,
			uploadedFileName,
		});

		if (!uploadedS3Key) {
			message.warning('Please select a file to upload');
			return;
		}

		setUploadLoading(true);
		message.loading({
			content: 'Processing bulk upload...',
			key: BULK_UPLOAD_MESSAGE_KEY,
		});

		try {
			// Call bulk upload API with the S3 key
			const response = await dispatch(
				bulkUploadRoutesV2({
					s3_key: uploadedS3Key,
					setErrors: (errors) => {
						console.error('❌ [Bulk Upload] API errors:', errors);
					},
				})
			);

			console.log('✅ [Bulk Upload] API response:', response);

			if (response?.status === 'success') {
				const { success_count, error_count, total_count, download_url } =
					response.data || {};

				message.success({
					content: `Bulk upload completed: ${success_count} succeeded, ${error_count} failed out of ${total_count} total`,
					key: BULK_UPLOAD_MESSAGE_KEY,
					duration: 5,
				});

				// If there's a download URL for errors, open it
				if (error_count > 0 && download_url) {
					console.log('📥 [Bulk Upload] Opening error report:', download_url);
					setTimeout(() => {
						window.open(download_url, '_blank');
					}, 500);
				}

				// Close modal and navigate back to list
				handleBulkUploadClose();
				navigate(ROUTE_LIST_ROUTE);
			} else {
				throw new Error(response?.error?.message || 'Bulk upload failed');
			}
		} catch (error) {
			console.error('❌ [Bulk Upload] Submission error:', error);
			message.error({
				content: error?.message || 'Failed to process bulk upload',
				key: BULK_UPLOAD_MESSAGE_KEY,
				duration: 5,
			});
		} finally {
			setUploadLoading(false);
		}
	};

	const formDisabled = isEditMode && isViewMode;
	const frozenInEdit = isEditMode;
	return (
		<PageContainer>
			<HeaderContainer>
				<BackButton as={ArrowLeftOutlined} onClick={() => navigate(ROUTE_LIST_ROUTE)} />
				<Box>
					<Title>Route Information</Title>
					<Subtitle style={{ marginTop: 8 }}>Create or Edit Route</Subtitle>
				</Box>
				{isEditMode ? (
					<HeaderRightSection>
						<ManageTripsButton onClick={handleManageTrips}>
							<UnorderedListOutlined />
							Manage Trips
						</ManageTripsButton>
						{isViewMode && (
							<EditButton type="primary" icon={<EditOutlined />} onClick={handleEdit}>
								Edit
							</EditButton>
						)}
					</HeaderRightSection>
				) : (
					<HeaderRightSection>
						<BulkUploadButton onClick={handleBulkUploadOpen}>
							<CloudUploadOutlined />
							Bulk Upload
						</BulkUploadButton>
					</HeaderRightSection>
				)}
			</HeaderContainer>

			<FormContainer>
				<StyledForm
					form={form}
					layout="vertical"
					onFinish={handleSubmit}
					initialValues={{
						movement_type: 'round_trip',
						trip_type: 'round_trip',
						is_active: true,
					}}
				>
					<FormRow>
						<FormColumn>
							<Form.Item
								name="project_id"
								label="Project Name"
								rules={
									isEditMode
										? []
										: [{ required: true, message: 'Please select project' }]
								}
							>
								<Select
									placeholder="Select project"
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) =>
										(option?.label ?? '')
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={projectOptions.map((p) => ({
										value: p.id,
										label: p.project_name || p.name,
									}))}
									disabled={formDisabled || frozenInEdit}
									onChange={() => form.setFieldValue('node_ids', [])}
								/>
							</Form.Item>
							<Form.Item
								name="route_name"
								label="Route Name"
								rules={
									isEditMode
										? []
										: [{ required: true, message: 'Please enter route name' }]
								}
							>
								<Input
									placeholder="e.g. Route_Mumbai_ROUT1"
									disabled={formDisabled || frozenInEdit}
								/>
							</Form.Item>
							<Form.Item
								name="vendor_id"
								label="Select vendor"
								rules={
									isEditMode
										? []
										: [{ required: true, message: 'Please select vendor' }]
								}
							>
								<Select
									placeholder="Select"
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) =>
										(option?.label ?? '')
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={vendorOptions}
									disabled={formDisabled || frozenInEdit}
								/>
							</Form.Item>
							<Form.Item
								name="vehicle_type"
								label="Vehicle Type"
								rules={
									isEditMode
										? []
										: [
												{
													required: true,
													message: 'Please select vehicle type',
												},
										  ]
								}
							>
								<Select
									placeholder={
										vendorId ? 'Select vehicle type' : 'Select vendor first'
									}
									options={vehicleTypeOptions}
									disabled={formDisabled || frozenInEdit}
									notFoundContent={
										vendorId
											? 'No vehicle types found'
											: 'Select vendor to load vehicle types'
									}
								/>
							</Form.Item>
							<Form.Item
								name="vehicle_id"
								label="Select Vehicle"
								rules={[
									{
										required: true,
										type: 'array',
										min: 1,
										message: 'Please select vehicle',
									},
								]}
							>
								<Select
									mode="multiple"
									placeholder={
										vehicleTypeId
											? 'Select vehicle'
											: 'Select vehicle type first'
									}
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) =>
										(option?.label ?? '')
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={vehicleOptions}
									disabled={formDisabled || (!isEditMode && !vehicleTypeId)}
									maxTagCount={2}
									maxTagPlaceholder={(omittedValues) =>
										`+${omittedValues.length}`
									}
								/>
							</Form.Item>
						</FormColumn>
						<FormColumn>
							<Form.Item
								name="warehouse"
								label="Warehouse Name"
								rules={
									isEditMode
										? []
										: [
												{
													required: true,
													message: 'Please enter warehouse name',
												},
										  ]
								}
							>
								<Input
									placeholder="e.g. Intelligent Warehouse"
									disabled={formDisabled || frozenInEdit}
								/>
							</Form.Item>
							<Form.Item
								name="trip_type"
								label="Trip Type"
								rules={
									isEditMode
										? []
										: [{ required: true, message: 'Please select trip type' }]
								}
							>
								<Select
									placeholder="Select"
									options={[
										{ value: 'round_trip', label: 'Round Trip' },
										{ value: 'one_way', label: 'One Way Trip' },
									]}
									disabled={formDisabled || frozenInEdit}
								/>
							</Form.Item>
							<Form.Item name="node_ids" label="Select Nodes">
								<Select
									mode="multiple"
									placeholder="Select"
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) =>
										(option?.label ?? '')
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={nodeOptions}
									disabled={formDisabled || frozenInEdit}
									onChange={handleNodeSelectionChange}
								/>
							</Form.Item>
							<NodeSequenceLink
								type="button"
								onClick={handleOpenNodeSequenceModal}
								disabled={formDisabled || frozenInEdit || !selectedNodeIds.length}
							>
								Select Node Sequence
							</NodeSequenceLink>
						</FormColumn>
					</FormRow>

					{isEditMode && (
						<Form.Item name="is_active" label="Status" hidden>
							<Input />
						</Form.Item>
					)}

					<Flex justifyContent="flex-end" mt={4}>
						{/* {isEditMode && (
							<>
								{isViewMode ? (
									<UpdateButton disabled>Update</UpdateButton>
								) : (
									<>
										<Button onClick={handleCancel} style={{ marginRight: 12 }}>
											Cancel
										</Button>
										<UpdateButton
											type="primary"
											onClick={() => form.submit()}
											loading={loading}
										>
											Update
										</UpdateButton>
									</>
								)}
							</>
						)} */}
						{isEditMode &&
							(isViewMode ? (
								<UpdateButton disabled>Update</UpdateButton>
							) : (
								<>
									<Button
										onClick={handleCancel}
										style={{ marginRight: 12, height: '40px' }}
									>
										Cancel
									</Button>
									<UpdateButton
										type="primary"
										onClick={() => form.submit()}
										loading={loading}
									>
										Update
									</UpdateButton>
								</>
							))}

						{!isEditMode && (
							<>
								<Button
									onClick={() => navigate(ROUTE_LIST_ROUTE)}
									style={{ marginRight: 12, height: '40px' }}
								>
									Cancel
								</Button>
								<UpdateButton
									type="primary"
									onClick={() => form.submit()}
									loading={loading}
								>
									Submit
								</UpdateButton>
							</>
						)}
					</Flex>
				</StyledForm>
			</FormContainer>

			{/* {isEditMode && bannerVisible && (
				<ViewBanner>
					<Flex alignItems="center" gap={8}>
						<EyeOutlined style={{ fontSize: 18 }} />
						<Text color="#fff" fontSize="14px">
							You can only view and comment on this file.
						</Text>
					</Flex>
					<Flex alignItems="center" gap={8}>
						<AskToEditButton size="small" onClick={handleEdit}>
							Ask to edit
						</AskToEditButton>
						<Button
							type="text"
							icon={<CloseOutlined />}
							onClick={() => setBannerVisible(false)}
							style={{ color: '#fff' }}
						/>
					</Flex>
				</ViewBanner>
			)} */}

			<BulkUploadModal
				visible={bulkUploadModalVisible}
				onClose={handleBulkUploadClose}
				onSubmit={handleBulkUploadSubmit}
				onFileUpload={handleFileUpload}
				title="Bulk Upload Routes"
				description="Upload a CSV file to create multiple routes at once. Required columns: route_name, project_id, vendor_id, vehicle_id, vehicle_type_id, trip_type, warehouse_name, node_ids, node_sequence_orders"
				templateUrl="/route_bulk_upload_template_v2.csv"
				templateText="Download the CSV template:"
				acceptedFormats=".csv"
				maxSizeMB={10}
				loading={uploadLoading}
			/>

			<ManageTripsModal
				visible={manageTripsModalVisible}
				onClose={handleCloseManageTrips}
				routeData={currentRouteData}
				onGenerateTrips={handleGenerateTrips}
				onDeleteTrips={handleDeleteTrips}
			/>

			<Modal
				visible={nodeSequenceModalVisible}
				title="Node Sequence"
				onCancel={() => setNodeSequenceModalVisible(false)}
				width={680}
				footer={[
					<Button key="reset" danger ghost onClick={handleResetSequence}>
						Reset Selection
					</Button>,
					<Button key="confirm" type="primary" onClick={handleConfirmNodeSequence}>
						Confirm
					</Button>,
				]}
			>
				<Form.Item label="Select Nodes" required>
					<Select
						mode="multiple"
						placeholder="Select"
						value={selectedNodeIds}
						showSearch
						optionFilterProp="children"
						filterOption={(input, option) =>
							(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						}
						options={nodeOptions}
						onChange={handleNodeSelectionChange}
					/>
				</Form.Item>

				<SequenceContainer>
					<SequenceHeader>
						<SequenceHeading>Arrange Sequence</SequenceHeading>
						<SequenceHint>Drag to reorder</SequenceHint>
					</SequenceHeader>

					{displaySequence.map((nodeId, index) => {
						const isRoundTripEndLocked =
							selectedTripType === 'round_trip' &&
							nodeOrder.length > 1 &&
							index === displaySequence.length - 1;
						const isStart = index === 0;
						const isEnd = index === displaySequence.length - 1;

						return (
							<SequenceRow
								key={`${nodeId}-${index}`}
								draggable={!isRoundTripEndLocked}
								onDragStart={() => handleDragStart(nodeId)}
								onDragOver={(event) => event.preventDefault()}
								onDrop={() => handleDropNode(nodeId)}
							>
								<Flex alignItems="center" gap={8}>
									<HolderOutlined style={{ color: '#94a3b8', fontSize: 16 }} />
									<SequenceIndex>{index + 1}</SequenceIndex>
									<span>{nodeOptionMap[nodeId] || `Node ${nodeId}`}</span>
								</Flex>
								<Flex alignItems="center" gap={8}>
									{isStart && <SequenceTag $variant="start">START</SequenceTag>}
									{isEnd && <SequenceTag $variant="end">END</SequenceTag>}
									{!isRoundTripEndLocked && (
										<Button
											type="text"
											icon={<MinusCircleOutlined />}
											onClick={() => handleRemoveNode(nodeId)}
										/>
									)}
								</Flex>
							</SequenceRow>
						);
					})}
				</SequenceContainer>
			</Modal>
		</PageContainer>
	);
}
